<template>
  <td class="multi-people-cell">
    <div
      :key="personId"
      v-for="personId in peopleIds"
    >
      <router-link
        :to="{
          name: 'person',
          params: {
            person_id: personId
          }
        }"
        class="person"
        :person="personMap.get(personId)"
        :style="getPersonStyle(personId)"
      >
        {{ personMap.get(personId).name }}
      </router-link>
    </div>
  </td>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'multi-people-name-cell',

  props: {
    peopleIds: {
      type: Array,
      default: () => []
    },
    highlight: {
      type: String,
      default: ''
    },
    avatars: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    ...mapGetters([
      'personMap'
    ])
  },

  methods: {
    getPersonStyle (persId) {
      const style = {
        'text-decoration': 'none',
        'font-weight': 'normal'
      }
      if (persId === this.highlight) {
        style['text-decoration'] = 'underline'
        style['font-weight'] = 'bold'
      }
      return style
    }
  }
}
</script>

<style>

.person {
  margin-left: 0;
  margin-right: 0.5em;
  border: none;
  color: var(--text);
}

.person::after {
  display: none;
}
</style>
